export default __webpack_public_path__ + "6f252505a7c7395f17f56c8a62005de1.jpeg";